
import type {
  DropdownParams,
  DynamicFieldData,
  FieldTypes,
  HeadParams,
  PhoneParams,
  TextareaParams,
} from '@restore/dynamic-forms';
import {
  DocumentServiceAddress,
  DocumentServiceFieldTypes,
  DocumentServiceField,
  DocumentServiceRadioCheckbox,
  DocumentServiceFullname,
  DocumentServiceTime,
  DocumentServiceCollapse,
  DocumentServiceDatetime,
} from './types';
import { address } from './address';
import { fullName } from './fullName';
import { radioCheckbox } from './radioCheckbox';
import { time } from './time';
import { convertBoolean } from './convertBoolean';
import { collapse } from './collapse';
import { datetime } from './datetime';

const parseFieldProperties = (
  field: DocumentServiceField<DocumentServiceFieldTypes>
): DynamicFieldData<FieldTypes> => {
  let fieldParams: FieldTypes;

  if (field.fieldParams) {
    switch (field.inputType) {
      case 'control_head':
        fieldParams = (field as DocumentServiceField<HeadParams>).fieldParams;
        break;
      case 'control_address':
        fieldParams = address((field as DocumentServiceField<DocumentServiceAddress>).fieldParams);
        break;
      case 'control_checkbox':
      case 'control_radio':
        fieldParams = radioCheckbox(
          (field as DocumentServiceField<DocumentServiceRadioCheckbox>).fieldParams
        );
        break;
      case 'control_fullname':
        fieldParams = fullName(
          (field as DocumentServiceField<DocumentServiceFullname>).fieldParams
        );
        break;
      case 'control_datetime':
        fieldParams = datetime(
          (field as DocumentServiceField<DocumentServiceDatetime>).fieldParams
        );
        break;
      case 'control_time':
        fieldParams = time((field as DocumentServiceField<DocumentServiceTime>).fieldParams);
        break;
      case 'control_dropdown':
        fieldParams = (field as DocumentServiceField<DropdownParams>).fieldParams;
        break;
      case 'control_email':
        fieldParams = (field as DocumentServiceField<undefined>).fieldParams;
        break;
      case 'control_phone':
        fieldParams = (field as DocumentServiceField<PhoneParams>).fieldParams;
        break;
      case 'control_textarea':
        console.log('field in textarea', field);
        fieldParams = (field as DocumentServiceField<TextareaParams>).fieldParams;
        break;
      case 'control_calculation':
      case 'control_textbox':
        fieldParams = (field as DocumentServiceField<undefined>).fieldParams;
        break;
      case 'control_collapse':
        fieldParams = collapse(
          (field as DocumentServiceField<DocumentServiceCollapse>).fieldParams,
          field.hidden
        );
        break;

      default:
    }
  }

  const genericFieldProperties = {
    label: field.label,
    defaultValue: field.defaultValue,
    inputType: field.inputType,
    fieldName: field.fieldName,
    id: field.id,
    order: field.order,
    required: convertBoolean(field.required),
    half: convertBoolean(field.half),
    newLine: convertBoolean(field.newLine),
    hidden: convertBoolean(field.hidden),
    validation: field.validation,
    config: field.config
      ? {
          ...field.config,
          required: convertBoolean(field.required),
          disabled: convertBoolean(field.config.disabled),
        }
      : {},
  };

  return { ...genericFieldProperties, fieldParams };
};

export const parseFields = (
  fieldArray: DocumentServiceField<DocumentServiceFieldTypes>[]
): DynamicFieldData<FieldTypes>[] => {
  return fieldArray.map((field) => {
    return parseFieldProperties(field);
  });
};
